import {RichTextStyleParams} from '@gongxigames/framework/core/fragments/BuilderY';
import {COLOR_HIGHLIGHT, COLOR_TEXT, AUTOPLAY_COUNTER_HIGHLIGHT} from '../../CONSTANTS';
import {RichText as RichTextConstructor} from '@gongxigames/framework/core/fragments/display';

export type UITextStyles =
    'POPUP_HEADER' |
    'POPUP_TEXT' |
    'POPUP_TEXT_UPPERCASE' |
    'POPUP_TEXT_HIGHLIGH' |
    'BET_SELECT' |
    'BET_SELECT_HIGHLIGH' |
    'POPUP_TEXT_BOLD' |
    'AUTOPLAY_COUNTER' |
    'AUTOPLAY_COUNTER_DISABLED' |
    'IN_BUTTON_TEXT' |
    'IN_BUTTON_TEXT_FOCUSED' |
    'FREE_SPIN_COUNTER' |
    'FREE_SPIN_COUNTER_DISABLED' |
    'BET_LABEL' |
    'BET_VALUE' |
    'BET_VALUE_PORTRAIT' |
    'WIN_VALUE' |
    'WIN_VALUE_LABEL' |
    'WIN_VALUE_PORTRAIT' |
    'WIN_VALUE_LABEL_PORTRAIT' |
    'TICKER_VALUE' |
    'TICKER_VALUE_PORTRAIT' |
    'WATERMARK' |
    'WATERMARK_RIGHT' |
    'WATERMARK_LEFT' |
    'WATERMARK_SLIM';

const BASE: RichTextStyleParams = {
    fill: COLOR_TEXT,
    fontFamily: 'Exo DemiBold',
    verticalAlign: 'center',
    align: 'center',
    fontWeight: 'lighter',
};

const IN_BUTTON_TEXT: RichTextStyleParams = {
    ...BASE,
    dropShadow: true,
    dropShadowAngle: 1.5,
    dropShadowBlur: 13,
    dropShadowColor: '#ffbb29',
    dropShadowDistance: 0,
    fontSize: 80,
    stroke: 0x000000,
    strokeThickness: 2
};

const STYLES: Record<UITextStyles, RichTextStyleParams> = {
    POPUP_HEADER: {
        ...BASE,
        fill: COLOR_HIGHLIGHT,
        fontSize: 24*3,
        wordWrapWidth: 900,
        wordWrap: true
    },
    POPUP_TEXT: {
        ...BASE,
        fontSize: 59,
    },
    POPUP_TEXT_UPPERCASE: {
        ...BASE,
        fontSize: 59,
        textTransform: 'uppercase',
        wordWrapWidth: 380,
        wordWrap: true
    },
    POPUP_TEXT_HIGHLIGH: {
        ...BASE,
        fill: COLOR_HIGHLIGHT,
        fontSize: 59,
        wordWrapWidth: 900,
        wordWrap: true
    },
    BET_SELECT: {
        ...BASE,
        fontSize: 56,
        fontFamily: 'Exo Bold',
    },
    BET_SELECT_HIGHLIGH: {
        ...BASE,
        fill: COLOR_HIGHLIGHT,
        fontSize: 56,
        fontFamily: 'Exo Bold',
    },
    POPUP_TEXT_BOLD: {
        ...BASE,
        fontSize: 72,
        fontFamily: 'Exo Bold',
    },
    AUTOPLAY_COUNTER: {
        ...BASE,
        fontSize: 72,
        fill: AUTOPLAY_COUNTER_HIGHLIGHT,
    },
    IN_BUTTON_TEXT: {
        ...IN_BUTTON_TEXT
    },
    IN_BUTTON_TEXT_FOCUSED: {
        ...IN_BUTTON_TEXT,
        dropShadowBlur: 16,
        dropShadowColor: '#ffc038',
        stroke: '#fff47a'
    },
    FREE_SPIN_COUNTER: {
        ...BASE,
        fontSize: 72,
        dropShadow: true,
        dropShadowColor: AUTOPLAY_COUNTER_HIGHLIGHT,
        dropShadowBlur: 5,
        dropShadowDistance: 0,
    },
    FREE_SPIN_COUNTER_DISABLED: {
        ...BASE,
        fontSize: 72,
        fill: 0x999999,
    },
    AUTOPLAY_COUNTER_DISABLED: {
        ...BASE,
        fontSize: 72,
    },
    BET_LABEL: {
        ...BASE,
        fontSize: 24,
        fill: COLOR_HIGHLIGHT,
        fontFamily: 'Exo Bold',
    },
    BET_VALUE: {
        ...BASE,
        fontSize: 42,
        fontFamily: 'Exo Bold',
    },
    BET_VALUE_PORTRAIT: {
        ...BASE,
        fontSize: 42,
        fill: COLOR_HIGHLIGHT,
        fontFamily: 'Exo Bold',
    },
    WIN_VALUE: {
        ...BASE,
        fontSize: 50,
        fontFamily: 'PF DinDisplay Pro',
    },
    WIN_VALUE_LABEL: {
        ...BASE,
        fontSize: 50,
        fill: COLOR_HIGHLIGHT,
        fontFamily: 'PF DinDisplay Pro',
    },
    WIN_VALUE_PORTRAIT: {
        ...BASE,
        fontSize: 46,
        fontFamily: 'PF DinDisplay Pro',
    },
    WIN_VALUE_LABEL_PORTRAIT: {
        ...BASE,
        fill: COLOR_HIGHLIGHT,
        fontSize: 46,
        fontFamily: 'PF DinDisplay Pro',
    },
    WATERMARK: {
        ...BASE,
        fontSize: 30,
        fontFamily: 'Exo Bold',
    },
    WATERMARK_RIGHT: {
        ...BASE,
        fontSize: 30,
        fontFamily: 'Exo Bold',
        align: 'right'
    },
    WATERMARK_LEFT: {
        ...BASE,
        fontSize: 30,
        fontFamily: 'Exo Bold',
        align: 'left'
    },
    WATERMARK_SLIM: {
        ...BASE,
        fontSize: 30,
    },
    TICKER_VALUE: {
        ...BASE,
        fill: COLOR_HIGHLIGHT,
        fontSize: 33,
        wordWrap: true,
        wordWrapWidth: 440
    },
    TICKER_VALUE_PORTRAIT: {
        ...BASE,
        fill: COLOR_HIGHLIGHT,
        fontSize: 33
    }
} as const;

for (const key in STYLES) {
    if (Object.prototype.hasOwnProperty.call(STYLES, key)) {
        RichTextConstructor.setStyle(key, STYLES[key as keyof typeof STYLES]);
    }
}

